export default "__VITE_ASSET__CWXQcapz__"